import React from 'react';
const RegisterRouter: React.FC<{ onRegistrationSuccess?: () => void }> = () => null;
export default RegisterRouter; 